import type { Invoice } from '../../Invoices/Types/invoicesTypes';
import { InvoiceType } from '../../Invoices/Types/invoicesTypes';
import { InvoiceTypeLabels } from '../../Invoices/Types/invoicesLabels';

export type ReservationInvoiceLookupSourceType = 'invoice-api';

export interface ReservationInvoiceLookup {
  id: number;
  number: string;
  typeLabel: string;
  sortOrder: number;
  issueDate: string;
  totalGross: number | null;
  currency?: string | null;
  sourceType: ReservationInvoiceLookupSourceType;
}

const getInvoiceSortOrder = (type: InvoiceType): number => {
  switch (type) {
    case InvoiceType.Prepayment:
      return 0;
    case InvoiceType.Final:
      return 1;
    case InvoiceType.Correction:
      return 2;
    case InvoiceType.Standard:
      return 3;
    case InvoiceType.Refund:
      return 4;
    case InvoiceType.Proforma:
      return 5;
    default:
      return 99;
  }
};

const resolveDisplayTotalGross = (dto: Invoice): number | null => {
  if (!Number.isFinite(dto.totalGross)) {
    return null;
  }

  const documentTotalAfterPrepayments = dto.documentTotalAfterPrepayments;
  if (
    dto.type === InvoiceType.Final &&
    typeof documentTotalAfterPrepayments === 'number' &&
    Number.isFinite(documentTotalAfterPrepayments)
  ) {
    return Math.max(0, documentTotalAfterPrepayments);
  }

  if (dto.type === InvoiceType.Final) {
    const prepaymentsSettledAmount = dto.prepaymentsSettledAmount;
    const settledPrepayments =
      typeof prepaymentsSettledAmount === 'number' && Number.isFinite(prepaymentsSettledAmount)
        ? prepaymentsSettledAmount
      : 0;

    return Math.max(0, dto.totalGross - settledPrepayments);
  }

  return dto.totalGross;
};

export const mapReservationInvoiceDtoToLookup = (
  dto: Invoice | undefined | null
): ReservationInvoiceLookup | undefined => {
  if (!dto?.id || !dto.invoiceNumber?.trim()) {
    return undefined;
  }

  return {
    id: dto.id,
    number: dto.invoiceNumber.trim(),
    typeLabel: InvoiceTypeLabels[dto.type] ?? 'Faktura',
    sortOrder: getInvoiceSortOrder(dto.type),
    issueDate: dto.issueDate,
    totalGross: resolveDisplayTotalGross(dto),
    currency: dto.currency,
    sourceType: 'invoice-api',
  };
};
